import React, { useEffect, useState } from "react";
import "../css/admissionDetails.css";
import { cufrontIcons } from "../../cufront-assets/icons/Icons";
import InputField from "../../common_component/component/InputField";
import CuDropdown from "../../common_component/component/CuDropdown";
import moment from "moment";
import { useAtom } from "jotai";
import { allClinicsAtom } from "../../_helper/constant/constant-atom";
import CuInput from "../../all-patient/components/CuInput";

// const billingUnits = [
//   { key: 1, value: 1, text: "CHAKAN" },
//   { key: 2, value: 2, text: "RAVET" },
// ];

const AdmissionDetails = ({
  isView,
  handleChange,
  value,
  billingUnit,
  isInstitutionPatient,
  billType,
}) => {
  const [allClinics] = useAtom(allClinicsAtom);
  const [billingUnitOptions, setBillingUnitOptions] = useState([]);

  useEffect(() => {
    if (allClinics) {
      const options = allClinics?.map((clinic) => ({
        key: clinic?.id,
        value: clinic?.id,
        text: clinic?.location,
      }));
      setBillingUnitOptions(options);
      //  //(allClinics, 'dsajsklajl')
    }
  }, [allClinics]);

  const handleDischarge = (e) => {
    // if (value?.admission_date) {
    //   const admissionDate = moment(value?.admission_date);
    //   const dischargeDate = moment(e.target.value);
    //   if (dischargeDate.isSameOrAfter(admissionDate)) {
    handleChange(
      { ...value, discharge_date: e.target.value },
      "admission_details"
    );
    //   }
    // }
  };

  // //(billingUnit, billingUnitOptions, 'kjadkal')

  return (
    <div className="cu-admission-info-div">
      {billType !== "OPD" && (
        <div className="cu-general-info-heading">
          <span>
            <img
              src={cufrontIcons.customer}
              alt="..."
              width={"22.59px"}
              height={"24px"}
            />
          </span>
          <span className="cu-create-invoice-heading-text">
            Admission Details
          </span>
        </div>
      )}

      <div className="cu-admission-details-cont">
        {billType !== "OPD" && (
          <>
            <div className="cu-admission-details-input">
              <div>
                <CuInput
                  label={"Admission Date"}
                  placeholder={"select"}
                  type={"date"}
                  disabled={isView}
                  value={value?.admission_date}
                  required={true}
                  onChange={(e) =>
                    handleChange(
                      { ...value, admission_date: e.target.value },
                      "admission_details"
                    )
                  }
                />
              </div>
              <div>
                <CuInput
                  label={"Admission Time"}
                  placeholder={"select"}
                  type={"time"}
                  disabled={isView}
                  value={value?.admission_time}
                  required={true}
                  onChange={(e) =>
                    handleChange(
                      { ...value, admission_time: e.target.value },
                      "admission_details"
                    )
                  }
                />
              </div>
            </div>
            <div className="cu-admission-details-input">
              <div>
                <CuInput
                  label={"Discharge Date"}
                  placeholder={"select"}
                  type={"date"}
                  disabled={isView}
                  required={true}
                  value={value?.discharge_date}
                  onChange={handleDischarge}
                />
              </div>
              <div>
                <CuInput
                  label={"Discharge Time"}
                  placeholder={"select"}
                  type={"time"}
                  disabled={isView}
                  required={true}
                  value={value?.discharge_time}
                  onChange={(e) =>
                    handleChange(
                      { ...value, discharge_time: e.target.value },
                      "admission_details"
                    )
                  }
                />
              </div>
            </div>
          </>
        )}
        <div className="cu-admission-details-input">
          <div style={{ width: "100%" }}>
            <label>Billing Unit</label>
            <CuDropdown
              options={billingUnitOptions}
              placeholder="Entity unit name of Hospital"
              disabled={isView}
              value={billingUnit}
              onChange={(val) => handleChange(val, "clinic_id")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionDetails;
